import { render, staticRenderFns } from "./CreateInventorySpecimens.vue?vue&type=template&id=920f845c&scoped=true"
import script from "./CreateInventorySpecimens.vue?vue&type=script&lang=js"
export * from "./CreateInventorySpecimens.vue?vue&type=script&lang=js"
import style0 from "./CreateInventorySpecimens.vue?vue&type=style&index=0&id=920f845c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920f845c",
  null
  
)

export default component.exports